import { KubernetesLiveUsageMgmtSlice } from "../../utils/types";
import { RootState } from "@/store/store";

export const kubernetesLiveUsageMgmtSliceSelector = (
  state: RootState,
): KubernetesLiveUsageMgmtSlice => state.kubernetesLiveUsageMgmtSlice;
